
export default function authHeader() {
  let token = localStorage.getItem('token');
  if (token != '') {
    return { Authorization: 'Bearer ' + window.localStorage.getItem('token') };
  } else {
    return {};
  }
}
